import { all } from 'redux-saga/effects';
import { unfixedConcat } from '../../../utils';
import { mapSagasFromConfigurations } from '../../helpers/sagas';
import { attemptConfigurations, questionAttemptConfigurations, questionConfigurations } from './configurations';

function* quizSagas() {
  yield all(
    unfixedConcat(
      mapSagasFromConfigurations('questions')(questionConfigurations),
      mapSagasFromConfigurations('attempts')(attemptConfigurations),
      mapSagasFromConfigurations('questionAttempts')(questionAttemptConfigurations)
    )
  );
}

export default quizSagas;



// WEBPACK FOOTER //
// ./src/state/modules/quiz/sagas.js